import {
  AvailabilityTierDeleteAndReassignRequestType,
  AvailabilityTierDeleteAndReassignResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useAvailabilityTierDeleteAndReassign = (
  availabilityTierId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: AvailabilityTierDeleteAndReassignRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `availability-tiers/${availabilityTierId}/delete-and-reassign`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as AvailabilityTierDeleteAndReassignResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.AvailabilityTiers,
          availabilityTierId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.AvailabilityTiers],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.AvailabilityTiers],
      });
    },
  });
};
